export enum OrderTypes {
  NEW = 'NEW',
  EXISTING = 'EXISTING',
  DEACTIVATION = 'DEACTIVATION',
  REPLACEMENT = 'REPLACEMENT',
  SWAP = 'SWAP'
}
